import React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
// components
import { Tab } from '@mui/material'
import { Tabs } from 'components/UI'
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout/index'
import SyncActiveDirectories from 'components/CTAs/SyncActiveDirectories'
import ActiveDirectoriesTable from './components/Table'
import ConnectActiveDirectory from 'components/CTAs/ConnectActiveDirectory'
// context
import TableManagementProvider from 'containers/Search/layers/BL'
// views
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Content = styled.div`
  margin-top: 16px;
  height: calc(100% - 66px);
`

const Integrations: React.FC = () => {
  const [tab, setTab] = React.useState(0)

  const handleSetTab = (_, value: number) => setTab(value)

  return (
    <>
      <Helmet>
        <title>Skefto - Integrations</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={false}
        CTA={
          <>
            <SyncActiveDirectories />
            <ConnectActiveDirectory />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
            <Tab label='Active Directory' />
          </Tabs>
          <Content>
            {tab === 0 && (
              <TableManagementProvider>
                <ActiveDirectoriesTable />
              </TableManagementProvider>
            )}
          </Content>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Integrations
